module.exports = __webpack_public_path__ + "static/media/bg-kota.003cc316.svg";